<template>
  <RequestView mode="create" v-bind="$attrs" />
</template>

<script>
import RequestView from "./RequestView.vue";

export default {
  name: "NewRequestView",
  inheritAttrs: false,
  components: { RequestView }
}
</script>
